import { render, staticRenderFns } from "./Authority.vue?vue&type=template&id=6b7052d7"
import script from "./Authority.vue?vue&type=script&lang=js"
export * from "./Authority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports